export default __webpack_public_path__ + "static/media/romania.0fd6a366.jpeg";